import PolicyLayout, { PolicySection } from "@/components/policy/PolicyLayout";

export default function PrivacyPolicy() {
  return (
    <PolicyLayout
      testId="privacy-policy-page"
      overline="Legal · Policies"
      title="Privacy"
      italicWord="Policy."
      updated="July 2026"
      intro="Your trust matters to us. This Privacy Policy explains what information we collect at innayaa.in, how we use it, and the choices you have."
    >
      <PolicySection n="1" title="Information We Collect">
        <p>When you place an order or interact with us, we may collect:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong className="text-[#2A2626]">Personal details:</strong> name, email address,
            phone number, shipping and billing address.
          </li>
          <li>
            <strong className="text-[#2A2626]">Order details:</strong> items purchased, order
            history, and payment gateway reference — we do not store card numbers.
          </li>
          <li>
            <strong className="text-[#2A2626]">Communication:</strong> messages you send us via
            email, contact form, WhatsApp, or Instagram.
          </li>
          <li>
            <strong className="text-[#2A2626]">Usage data:</strong> device type, browser, pages
            visited, and general location — collected via cookies and analytics tools to
            improve the site.
          </li>
        </ul>
      </PolicySection>

      <PolicySection n="2" title="How We Use Your Information">
        <ul className="list-disc pl-5 space-y-2">
          <li>To process and fulfil your orders, and to send order-related communication (confirmation, dispatch, tracking, care instructions).</li>
          <li>To respond to your questions, requests, or return / exchange claims.</li>
          <li>With your consent, to send occasional updates about new drops, gemstone stories, and offers. You can unsubscribe at any time.</li>
          <li>To improve our website, products, and customer experience.</li>
          <li>To detect, prevent, and address fraud, misuse, or legal violations.</li>
        </ul>
      </PolicySection>

      <PolicySection n="3" title="Sharing Your Information">
        <p>
          We <strong className="text-[#2A2626]">do not sell</strong> your personal information.
          We share it only with trusted service providers who help us run the business:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong className="text-[#2A2626]">Logistics partners</strong> — to deliver your
            parcel and enable tracking.
          </li>
          <li>
            <strong className="text-[#2A2626]">Payment gateway</strong> — to securely process
            online payments when applicable.
          </li>
          <li>
            <strong className="text-[#2A2626]">Email &amp; hosting providers</strong> — to send
            transactional emails and to host innayaa.in.
          </li>
          <li>
            <strong className="text-[#2A2626]">Analytics providers</strong> — to understand
            aggregate site usage.
          </li>
          <li>
            To comply with a lawful request, court order, or applicable regulation.
          </li>
        </ul>
        <p>
          Each of these partners is bound by their own privacy commitments and processes
          only the data required to serve you.
        </p>
      </PolicySection>

      <PolicySection n="4" title="Cookies & Analytics">
        <p>
          Innayaa.in uses cookies and similar technologies to remember your cart, keep you
          signed in, and understand how visitors use the site. You can disable cookies in
          your browser at any time; some parts of the site may not work as intended if you do.
        </p>
      </PolicySection>

      <PolicySection n="5" title="Data Retention">
        <p>
          We retain personal information for as long as needed to fulfil the purposes
          described above — typically for the duration of your relationship with us plus a
          reasonable period after, to comply with legal, tax, and accounting obligations.
        </p>
      </PolicySection>

      <PolicySection n="6" title="Your Rights">
        <p>You have the right to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Access the personal information we hold about you.</li>
          <li>Ask us to correct any inaccurate or incomplete information.</li>
          <li>Ask us to delete your personal information, subject to legal retention obligations.</li>
          <li>Withdraw consent for marketing communication at any time.</li>
        </ul>
        <p>
          To exercise any of these rights, write to us at{" "}
          <a href="mailto:innayaaofficial@gmail.com" className="text-[#2A2626] link-underline">
            innayaaofficial@gmail.com
          </a>
          . We will respond within a reasonable time.
        </p>
      </PolicySection>

      <PolicySection n="7" title="Security">
        <p>
          We use reasonable technical and organisational safeguards to protect your
          information. However, no method of transmission over the internet is 100% secure —
          we encourage you to also protect your passwords and personal devices.
        </p>
      </PolicySection>

      <PolicySection n="8" title="Children's Privacy">
        <p>
          Innayaa.in is not directed at children under 18. We do not knowingly collect
          personal information from minors without parental consent. If you believe a minor
          has provided us with personal information, please contact us and we will delete it.
        </p>
      </PolicySection>

      <PolicySection n="9" title="Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. When we do, the &ldquo;Last updated&rdquo;
          date at the top will change. Please review this page periodically.
        </p>
      </PolicySection>

      <PolicySection n="10" title="Contact">
        <p>
          For any privacy-related questions or requests, please email us at{" "}
          <a href="mailto:innayaaofficial@gmail.com" className="text-[#2A2626] link-underline">
            innayaaofficial@gmail.com
          </a>
          .
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}
